import { Injectable } from '@angular/core'
import { NgxSonnerToaster, toast } from 'ngx-sonner'

@Injectable({
    providedIn: 'root',
})
export class AlertService {
    success(message: string, description?: string) {
        toast.success(message, { description })
    }

    error(message: string, description?: string) {
        toast.error(message, { description })
    }

    warning(message: string, description?: string) {
        toast.warning(message, { description })
    }

    info(message: string, description?: string) {
        toast.info(message, { description })
    }

    plain(message: string, description?: string) {
        toast(message, {
            description,
        })
    }

    loading(message = 'Please wait...', duration = 2000) {
        toast.loading(message, { duration })
    }
}
